import React from 'react';
import styled from 'styled-components';

import { RadioFieldWrapper } from './styled.js';

const RadioGroup = props => {
  const {
    id,
    nameType,
    formValid,
    formErrors,
    handleFocus: onFocus,
    handleChange: onChange,
    values = {},
    options,
    ...rest
  } = props;

  let { value } = props;

  const handleFocus = value => {
    if (onFocus !== undefined) onFocus(id, value);
  };

  const handleChange = event => {
    if (onChange !== undefined) onChange(id, event.target.value);
  };

  value = value || (values && values[id]);

  return (
    <>
      <RadioGroupTitle htmlFor={id} className="radio-field--title">
        {nameType}
      </RadioGroupTitle>
      <RadioFieldWrapper
        formValid={formValid}
        id={id}
        className={`radio-field-wrapper${formValid[id] === -1 ? ' radio-field-error' : ''}`}
      >
        {options.map((item, index) => {
          const checked = value === item.value;
          const labelId = `${id}-${Math.floor(Math.random() * 100000000)}`;

          return (
            <div className={`radio-div ${checked ? 'selected' : ''}`} key={index}>
              <input
                name={id}
                id={labelId}
                type="radio"
                value={item.value}
                onChange={handleChange}
                checked={checked}
              />
              <label htmlFor={labelId} onClick={() => handleFocus(item.value)}>
                {item.label}
              </label>
            </div>
          );
        })}
      </RadioFieldWrapper>
    </>
  );
};

const RadioGroupTitle = styled.label`
  font-family: Sofia Pro;
  font-size: 16px !important;
  font-weight: 600;
  line-height: 23px;
  color: var(--neutral-text-color);
  margin-bottom: 16px;
`;

export default RadioGroup;
